import script from "./CalculatorDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./CalculatorDetail.vue?vue&type=script&setup=true&lang=js"

import "./CalculatorDetail.vue?vue&type=style&index=0&id=462c1cac&scoped=true&lang=css"
import "./CalculatorDetail.vue?vue&type=style&index=1&id=462c1cac&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462c1cac"]])

export default __exports__